export default {
  all: 'Alle',
}
